import script from "./pickCustCompany.vue?vue&type=script&setup=true&lang=js"
export * from "./pickCustCompany.vue?vue&type=script&setup=true&lang=js"

import "./pickCustCompany.vue?vue&type=style&index=0&id=47b1f6b0&lang=css"

const __exports__ = script;

export default __exports__